import { Component, OnInit } from '@angular/core';
import { faChartPie, faPlus, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationService } from 'app/core/services/configuration/configuration.service';
import { columnHeader } from 'app/shared/factoring-datatable/factoring-datatable.component';
import { ConfirmModalComponent } from 'app/shared/utils/confirm-modal/confirm-modal.component';
import { ManageParametrosModalComponent } from '../modals/manage-parametros-modal/manage-parametros-modal.component';
import { functions } from '../../../core/helpers/functions';

@Component({
  selector: 'app-parametros',
  templateUrl: './parametros.component.html',
  styleUrls: ['./parametros.component.css']
})
export class ParametrosComponent implements OnInit {
   faPlus = faPlus;
  faChartPie = faChartPie;
  faSyncAlt = faSyncAlt;
  public rowData          : any[]   = [];
	public loadingTable     : boolean = false;
	public columnDefs       : columnHeader[];
	public pageTableActual  : number;
	public pageTableTotal   : number;
	public pageTablePerPages: number  = 10;
	public pageTablePages   : number[];
	public user             : any;
	public identidad        : any     = {};
	public searchstring     : string = '';
	public canCreate: boolean = false;

  constructor(
    private configurationService  : ConfigurationService,
    public modalService           : NgbModal,
  ) { }

  ngOnInit(): void {
    this.obtenerParametros();
  }

  loadTable(data) {
    this.rowData = functions.indextable( data )
    // this.rowData           = data.results
    this.pageTableActual   = data.page_number
    this.pageTableTotal    = data.count
    this.pageTablePerPages = data.per_page
    this.pageTablePages = []
    for (let index = 0; index < data.num_pages; index++) {
      this.pageTablePages.push(index)
    }
  }
    
  initVars() {
    let columns = [
      {
        headerName: 'N°', 
        field     : 'index' ,
        sortable  : true,
      },
      {
        headerName: 'Parámetro', 
        field     : 'parametro',
        sortable  : true,
      },
      {
        headerName: 'Descripción', 
        field     : 'descripcion',
        sortable  : true,
      },
      {
        headerName: 'Valor', 
        field     : 'valor',
        sortable  : true,
      },
    ];
  
    this.columnDefs = columns;
  }

  obtenerParametros(page = 1, page_size = 10) {
    let Parametros = this.configurationService.obtenerParametros(page, page_size);

    Promise.all([Parametros]).then((res :any[])=>{
      console.log("RES", res)
      let Parametros  = res[0];
      this.initVars();
      this.loadTable(Parametros);
    });
  }

  crear() {
    const modalRef = this.modalService.open(ManageParametrosModalComponent, {
    });

    modalRef.result.then((result) => {
          console.log(result);
      }, (reason) => {
          console.log(reason);
    });

    modalRef.componentInstance.successEmit.subscribe(result => {
			console.log(result);
			this.obtenerParametros();
		},
		error => {
      console.error(error);
      
		});
  }

  tableEditEvent(row) {
    const modalRef = this.modalService.open(ManageParametrosModalComponent, {
    });

    modalRef.componentInstance.parametroId = row.id;

    modalRef.componentInstance

    modalRef.result.then((result) => {
          console.log(result);
      }, (reason) => {
          console.log(reason);
    });

    modalRef.componentInstance.successEmit.subscribe(result => {
			console.log(result);
			this.obtenerParametros();
		},
		error => {

		});
  }

  destroy(row) {
    const modalRef = this.modalService.open(ConfirmModalComponent, {
		
		});

		modalRef.componentInstance.title = 'Remover Parámetro';
		modalRef.componentInstance.message = '¿Seguro que desea remover el Parámetro?';
		
		modalRef.result.then((result) => {
		if (result) {
			this.configurationService.eliminarParametro(row.id)
			.then(result => {
			this.obtenerParametros();
			})
			.catch(error => {
			console.error(error);
			});
		}
		}, (reason) => {
			console.log(reason);
		});
  }

  goToPage({page,per_page,filtros}) {
    this.obtenerParametros(page, per_page);
  }
 
}
